import { AbstractControl, Validators, ValidatorFn } from "@angular/forms";
import { isValidNumber, CountryCode } from "libphonenumber-js";
import { isPresent } from "../../helpers/function";

export const phone = (country: CountryCode): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } => {
    if (isPresent(Validators.required(control))) return null;

    const v: string = control.value;

    return isValidNumber({ phone: v, country }) ? null : { phone: true };
  };
};
